import React from 'react';

import { AppState } from '../types/game';
import downIcon from '../assets/down.svg';
import closeIcon from '../assets/close.svg';
import './TitleBar.css';

interface TitleBarProps {
  title: string;
  timer?: string;
  appState: AppState;
  setAppState: (state: AppState) => void;
  location?: string;
}

const TitleBar: React.FC<TitleBarProps> = ({ title, timer, appState, setAppState, location }) => {
  // Check if we're on product or rules page
  const isProductOrRulesPage = location?.includes('/product/') || location?.includes('/rules');

  // Show appropriate icon based on app state
  const icon = appState === 'collapsed' ? closeIcon : downIcon;
  const iconAlt = appState === 'collapsed' ? 'Close' : 'Down';

  // Handle icon click - collapse when expanded, dismiss when collapsed
  const handleIconClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent the click from bubbling to the container

    // Disable functionality on product/rules pages
    if (isProductOrRulesPage) {
      return;
    }

    if (appState === 'expanded') {
      setAppState('collapsed'); // Same effect as clicking the titlebar itself
    } else if (appState === 'collapsed') {
      setAppState('dismissed'); // Only dismiss when already collapsed
    }
  };

  return (
    <div className="title-bar">
      {appState === 'collapsed' && <h1 className="title-bar-text">{title}</h1>}
      <div className="title-bar-right">
        {appState === 'collapsed' && timer && <div className="title-bar-timer">{timer}</div>}
      </div>
      {!isProductOrRulesPage && (
        <button className="title-bar-button" onClick={handleIconClick}>
          <img src={icon} alt={iconAlt} />
        </button>
      )}
    </div>
  );
};

export default TitleBar;
